module.exports = __webpack_public_path__ + "img/Contract.ba415aaf.svg";